<template>
  <div class="achievements-search">
    <div class="table-section">
      <el-card shadow="never">
        <el-form :inline="true" :model="searchParams" class="demo-form-inline" >
          <el-form-item label="机构">
            <el-input v-model.trim="searchParams.institutions" placeholder="机构" />
          </el-form-item>
          <el-form-item label="队列">
            <el-input v-model.trim="searchParams.customGroupId" placeholder="队列" />
          </el-form-item>
          <el-form-item label="操作人">
            <el-input v-model.trim="searchParams.name" placeholder="操作人" />
          </el-form-item>
          <el-form-item label="姓名">
            <el-input v-model.trim="searchParams.userName" placeholder="姓名" />
          </el-form-item>
          <el-form-item label="还款时间">
            <el-date-picker v-model="searchParams.repayTime" value-format="yyyy-MM-dd HH:mm:ss" type="datetimerange"
              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="repayTimeChange" />
          </el-form-item>
          <el-form-item label="分案日期">
            <el-date-picker v-model="searchParams.fenAn" value-format="yyyy-MM-dd HH:mm:ss" type="datetimerange"
              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="fenAnChange" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="search">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button @click="clear">清空</el-button>
          </el-form-item>
          <el-form-item>
            <el-button @click="download">导出</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>
    <el-table :data="tableData" :header-row-style="headerRowStyle" max-height="550px" class="table-section" border
      highlight-current-row style="width: 100%">
      <el-table-column prop="id" label="贷款编号" width="70">
        <template slot-scope="scope">
          <router-link :to="{ name: 'taskDetail', params: { loanId: 0, taskId: scope.row.taskId, type: 'none' } }">{{
          scope.row.id }}</router-link>
        </template>
      </el-table-column>
      <el-table-column prop="borrowerId" label="用户Id" width="70" />
      <el-table-column prop="userName" label="用户姓名" width="70" />
      <el-table-column prop="institutionName" label="机构" />
      <el-table-column prop="customGroupId" label="队列" width="70" />
      <el-table-column prop="name" label="操作人" />
      <el-table-column prop="createDate" label="分案日期" />
      <el-table-column prop="amount" label="应还未还总额" />
      <el-table-column prop="repayAmount" label="还款金额" />
      <el-table-column prop="repayOriginAmount" label="本金利息" />
      <el-table-column prop="repayOverdueAmount" label="罚息" />
      <el-table-column prop="repayManageAmount" label="逾期管理费" />
      <el-table-column prop="repayDelayAmount" label="违约金" />
      <el-table-column prop="repayTime" label="还款时间" />
    </el-table>
    <el-card class="box-card" shadow="never">
      <span class="total-item">
        违约金：{{ totalData.totalRepayDelayAmount }}
      </span>
      <span class="total-item">
        逾期管理费：{{ totalData.totalRepayManageAmount }}
      </span>
      <span class="total-item">
        罚息：{{ totalData.totalRepayOverdueAmount }}
      </span>
      <span class="total-item">
        本金利息：{{ totalData.totalRepayOriginAmount }}
      </span>
      <span class="total-item">
        总计：{{ totalData.totalRepayAmount }}
      </span>
      <div class="total-last" />
    </el-card>
    <div class="pagination-section">
      <el-pagination :page-size="pageSize" :total="total" :page-sizes="[5, 10, 15, 20]"
        layout="total, sizes, prev, pager, next" @current-change="changePage" @size-change="changeSize" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import * as achievementsApi from '../../api/achievements.js'
import api from '../../api.js'
const moment = require('moment')

export default {
  name: 'achievements-search',
  data() {
    return {
      searchParams: {
        repayTime: '',
        fenAn: ''
      },
      headerRowStyle: {
        'background-color': '#6584b4'
      },
      pageSize: 5,
      page: 1,
      total: 0,
      tableData: [],
      totalData: {}
    }
  },
  computed: {
    ...mapGetters([
      'currentUser'
    ])
  },
  created() {
    this.getList()
    this.getTotal()
  },
  methods: {
    fenAnChange(val) {
      if (val && val.length) {
        this.searchParams.fenAnBeginTime = val[0]
        this.searchParams.fenAnEndTime = val[1]
      } else {
        this.searchParams.fenAnBeginTime = ''
        this.searchParams.fenAnEndTime = ''
      }
    },
    repayTimeChange(val) {
      if (val && val.length) {
        this.searchParams.repayBeginTime = val[0]
        this.searchParams.repayEndTime = val[1]
      } else {
        this.searchParams.repayBeginTime = ''
        this.searchParams.repayEndTime = ''
      }
    },
    /**
     * 获取列表
     */
    async getList() {
      const res = await achievementsApi.getTaskReportList(Object.assign({
        page: this.page,
        size: this.pageSize,
        userId: this.currentUser.id
      }, this.searchParams))
      res.data.records.map(item => {
        item.repayTime = moment(item.repayTime).format('YYYY-MM-DD HH:mm:ss')
        item.createDate = moment(item.createDate).format('YYYY-MM-DD HH:mm:ss')
      })
      this.$set(this, 'tableData', res.data.records)
      this.$set(this, 'total', res.data.total)
    },
    /**
     * 获取总数
     */
    async getTotal() {
      const res = await achievementsApi.getTotal(Object.assign({
        userId: this.currentUser.id
      }, this.searchParams))
      this.$set(this, 'totalData', res.data)
    },
    /**
     * 导出
     */
    download() {
      const ops = {
        userId: this.currentUser.id,
        rowName: '贷款编号,用户Id,用户姓名,机构,队列,操作人,分案日期,应还未还总额,还款金额,本金利息,逾期费用,逾期管理费,违约金,还款时间',
        rowNameEn: 'id,borrowerId,userName,institutions,customGroupId,name,createDate,amount,repayAmount,repayOriginAmount,repayOverdueAmount,repayManageAmount,repayDelayAmount,repayTime'
      }
      api.downloadAchievements(Object.assign(ops, this.searchParams))
    },
    /**
     * 切换页数
     */
    changePage(currentPage) {
      this.page = currentPage
      this.getList()
    },
    /**
     * 切换size
     */
    changeSize(currentSize) {
      this.pageSize = currentSize
      this.page = 1
      this.getList()
    },
    /**
     * 搜索
     */
    search() {
      this.page = 1
      this.getList()
      this.getTotal()
    },
    /**
     * 清空
     */
    clear() {
      this.searchParams = {}
    }
  }
}
</script>

<style scoped>
.box-card {
  margin-top: 20px;
}

.table-section {
  margin-top: 20px;
}

.total-last {
  clear: both;
}

.total-item {
  float: right;
  margin-right: 60px;
}
</style>
